const STOCKREPORTAPI = {
  ALLSTOCKREPORTAPI: `clients/StockReport`,
};

export default STOCKREPORTAPI;
